'use client'

import Image from 'next/image'

import styles from './styles.module.scss'
import { Container } from '..'
import logoUrl from '/public/icons/logo-white.svg'

export default function Footer({variant}) {
  return (
    <footer className={`${styles.footer} ${styles[`footer--${variant}`]}`}>
      <Container classname={styles.footer__container}>
        <Image
          quality={100}
          src={logoUrl}
          alt="Logo Foguete"
          width={224}
          height={40}
        />
      </Container>
    </footer>
  )
}
